module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Notification#2-15e15493f899e3250ba68340b7fe19c1.svg";